export default __webpack_public_path__ + "static/media/arbitrum.20df7bed.svg";